// ? Delete?
import React from 'react';
import { getLocalizedDetailedPagePath } from '../../affilate-logic/roche-ch';
import { LanguageService } from '../../services/language';

interface AvailableLanguagesProps {
  slot?: string;
  languages: Array<string>;
  slug: string;
  locale?: string;
}

export const AvailableLanguages = (props: AvailableLanguagesProps): JSX.Element => {
  const currentLanguage = props.locale ? props.locale : LanguageService.getActiveLanguage();
  const availableLanguages = props.languages.filter((language) => language !== currentLanguage);

  const links = availableLanguages.map((language) => (
    <roche-text-link
      key={language}
      class='available-languages__language-switch'
      href={
        props.locale
          ? LanguageService.getLocaleAwareLink(
              `${getLocalizedDetailedPagePath(language)}/informationen/${props.slug}`,
              language,
            )
          : LanguageService.getLocaleAwareLink(props.slug, language)
      }
      text={language.toUpperCase()}
    ></roche-text-link>
  ));

  if (!links.length) {
    return null;
  }

  return (
    <div slot={props.slot}>
      <style>
        {`
          .available-languages__language-switch + .available-languages__language-switch::before {
            content: " | ";
            white-space: pre;
          }
        `}
      </style>
      {links}
    </div>
  );
};
